import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {map, catchError} from 'rxjs/operators';
import {Observable} from 'rxjs';

import {endpoints} from '../endpoints';

@Injectable({
  providedIn: 'root'
})
export class SolicitarconfirmacionService {
  constructor(private http: HttpClient) {
  }

  reenviarcodigoconfirmacion(correo: string): Observable<any> {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const parametros = {
      correo
    };
    return this.http.post(endpoints.registro.reenviar, JSON.stringify(parametros), {headers})
      .pipe(map(results => {
        return results;
      }), catchError(error => {
        console.log('Error desde endpoint reset, ', error);
        throw new Error(error.error.message);
      }));
  }

}
